<template>
    <BaseModal @close="handleClose">
        <template #header>
            <h3 id="base-modal-title" class="reload-modal__title" tabindex="-1" ref="reloadModalTitle">
                {{ $ml.get('reloadCountdownModalTitle') }}
            </h3>
        </template>

        <span class="reload-modal__subtitle">
            {{ $ml.get('reloadCountdownModalSubtitle') }}
        </span>

        <div class="reload-modal__countdown">
            <span>{{ formattedCountdown }}</span>
        </div>

        <template #footer>
            <button class="base-modal__btn base-modal__btn--primary base-modal__btn--full-width" @click="handleReload">
                <span>
                    {{ $ml.get('reloadCountdownModalButton') }}
                </span>
            </button>
        </template>
    </BaseModal>
</template>

<script>
    import BaseModal from '@/components/template/BaseModal';

    export default {
        components: { 
            BaseModal,
        },

        props: {
            seconds: {
                type: Number,
                default: 10
            }
        },

        data() {
            return {
                countdown: this.seconds,
                intervalId: null
            };
        },

        computed: {
            formattedCountdown() {
                const min = Math.floor(this.countdown / 60);
                const sec = this.countdown % 60;
                return `${min.toString().padStart(2, '0')}:${sec.toString().padStart(2, '0')}`;
            }
        },

        mounted() {
            this.$nextTick(() => {
                if (this.$refs.reloadModalTitle) {
                    this.$refs.reloadModalTitle.focus();
                }
            });
            this.startCountdown();
            document.addEventListener('keydown', this.handleEsc);
        },
        
        beforeDestroy() {
            this.clearCountdown();
            document.removeEventListener('keydown', this.handleEsc);
        },

        methods: {
            startCountdown() {
                this.intervalId = setInterval(() => {
                    if (this.countdown > 1) {
                        this.countdown--;
                    } else {
                        this.handleReload();
                    }
                }, 1000);
            },

            clearCountdown() {
                if (this.intervalId) {
                    clearInterval(this.intervalId);
                    this.intervalId = null;
                }
            },

            reloadPage() {
                this.clearCountdown();
                window.location.reload();
            },

            handleReload() {
                this.reloadPage();
            },
            
            handleClose() {
                this.reloadPage();
            },

            handleEsc(e) {
                if (e.key === 'Escape') {
                    this.handleClose();
                }
            }
        }
    };
</script>

<style scoped lang="scss">
    .reload-modal {

        &__title {
            font-size: 1.25rem;
            font-weight: 700;
            color: #2F363E;
        }

        &__subtitle {
            font-size: 1rem;
            font-weight: 500;
            color: #454F5C;
            margin-bottom: 16px;
            display: block;
        }

        &__countdown {
            font-size: 1.5rem;
            font-weight: 700;
            color: #2F363E;
            margin-bottom: 24px;
            text-align: center;
        }
    }
</style>
